const formatNumberWithPlus = (num) => {
    if (!num) {
        return undefined;
    }
    const rounded = Math.floor(num / 50) * 50;
    return `${rounded}+`;
};

export { formatNumberWithPlus };
